import { render, staticRenderFns } from "./tiku_search.vue?vue&type=template&id=727652c2&scoped=true&"
import script from "./tiku_search.vue?vue&type=script&lang=js&"
export * from "./tiku_search.vue?vue&type=script&lang=js&"
import style0 from "./tiku_search.vue?vue&type=style&index=0&id=727652c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727652c2",
  null
  
)

export default component.exports